import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "../../../components/admin/AdminLayout";
import AdminDashboard from "../dashboard/AdminDashboard";
import BlogAdmin from "../blogs/BlogAdmin";
import BlogForm from "../blogs/BlogForm";
import CourseAdmin from "../courses/CourseAdmin";
import CourseForm from "../courses/CourseForm";
import TestimonialAdmin from "../testimonials/TestimonialAdmin";
import TestimonialForm from "../testimonials/TestimonialForm";
import FAQAdmin from "../faq/FAQAdmin";
import FAQForm from "../faq/FAQForm";
import PlatformFeatureAdmin from "../platform-features/PlatformFeatureAdmin";
import PlatformFeatureForm from "../platform-features/PlatformFeatureForm";
import StatsAdmin from "../stats/StatsAdmin";
import HomeAdmin from "../home/HomeAdmin";
import AboutAdmin from "../about/AboutAdmin";
import FounderStoryAdmin from "../founder/FounderStoryAdmin";
import MethodologyAdmin from "../methodology/MethodologyAdmin";
import PlanAdmin from "../plans/PlanAdmin";
import PlanComparisonAdmin from "../plans/PlanComparisonAdmin";
import UserAdmin from "../users/UserAdmin";
import CompanyQuestions from "../questions/CompanyQuestions";
import AddQuestions from "../questions/AddQuestions";
import CreateInternTest from "../intern-assessment/CreateInternTest";
import InternTestResults from "../intern-assessment/InternTestResults";
import RoleManager from "../role-manager/RoleManager"

import AdminBootcampDashboard from "../bootcamp/AdminBootcampDashboard";
import CreateBootcamp from "../bootcamp/CreateBootcamp";
import BootcampList from "../bootcamp/BootcampList";
import BootcampRegistrations from "../bootcamp/BootcampRegistrations";
import FeedbackResponses from "../bootcamp/feedback/FeedbackResponses";
const AdminRoutes = () => {
  return (
    <Routes>
      {/* ADMIN LAYOUT */}
      <Route element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="dashboard" element={<AdminDashboard />} />

        <Route path="blogs" element={<BlogAdmin />} />
        <Route path="blogs/new" element={<BlogForm />} />
        <Route path="blogs/edit/:id" element={<BlogForm />} />

        <Route path="courses" element={<CourseAdmin />} />
        <Route path="courses/new" element={<CourseForm />} />
        <Route path="courses/:id/edit" element={<CourseForm />} />

        <Route path="testimonials" element={<TestimonialAdmin />} />
        <Route path="testimonials/new" element={<TestimonialForm />} />
        <Route path="testimonials/edit/:id" element={<TestimonialForm />} />

        <Route path="faqs" element={<FAQAdmin />} />
        <Route path="faqs/new" element={<FAQForm />} />
        <Route path="faqs/edit/:id" element={<FAQForm />} />

        <Route path="platform-features" element={<PlatformFeatureAdmin />} />
        <Route path="platform-features/new" element={<PlatformFeatureForm />} />
        <Route path="platform-features/:id" element={<PlatformFeatureForm />} />

        <Route path="stats" element={<StatsAdmin />} />
        <Route path="home" element={<HomeAdmin />} />
        <Route path="about" element={<AboutAdmin />} />
        <Route path="founder" element={<FounderStoryAdmin />} />
        <Route path="role-manager" element={<RoleManager />} />
        <Route path="methodology" element={<MethodologyAdmin />} />
<Route path="plans" element={<PlanAdmin />} />
        <Route path="plan-comparison" element={<PlanComparisonAdmin />} />
        <Route path="questions/add" element={<CompanyQuestions />} />
        <Route path="questions/upload" element={<AddQuestions />} />
        <Route path="users" element={<UserAdmin />} />

  <Route path="bootcamp" element={<AdminBootcampDashboard />} />

<Route path="bootcamp/create" element={<CreateBootcamp />} />

<Route path="bootcamp/list" element={<BootcampList />} />

<Route path="bootcamp/registrations" element={<BootcampRegistrations />} />
        
<Route
  path="intern-assessment/create"
  element={<CreateInternTest />}
/>

<Route
  path="intern-assessment/results"
  element={<InternTestResults />}
/>
<Route
  path="/feedback/:bootcampId"
  element={<FeedbackResponses />}
/>
        {/* fallback */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
        
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
